import { Paper } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { ConfirmationDialog } from "@dzambalaorg/mui-dialog-confirmation";
import type { IPredictionAnswer } from "@framework/types";
import { Table } from "@dzambalaorg/ui-kit";

export interface IPredictionAnswerViewDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  viewItem: IPredictionAnswer | null;
}

export const PredictionAnswerViewDialog = (props: IPredictionAnswerViewDialogProps) => {
  const { open, viewItem, onConfirm, ...rest } = props;

  if (!open || !viewItem) {
    return null;
  }

  const { answer } = viewItem;

  const handleConfirm = (): void => {
    onConfirm();
  };

  return (
    <ConfirmationDialog open={open} message="dialogs.view" onConfirm={handleConfirm} {...rest}>
      <Table.Container component={Paper}>
        <Table aria-label="raffle token table">
          <Table.Body>
            <Table.Row>
              <Table.Cell component="th" scope="row">
                <FormattedMessage id="form.labels.answer" />
              </Table.Cell>
              <Table.Cell align="right">{answer}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Table.Container>
    </ConfirmationDialog>
  );
};
